// extracted by mini-css-extract-plugin
export default {"ant-notification":"RlDCL","antNotification":"RlDCL","search-form":"gjwsp","searchForm":"gjwsp"};